(function () {
  if (document.documentElement.dataset.tcQuickAddInitialized === 'true') return;
  document.documentElement.dataset.tcQuickAddInitialized = 'true';

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-tc-quick-add]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    event.stopPropagation();

    const form = button.form;
    const variantInput = form && form.querySelector('input[name="id"]');
    const variantId = button.dataset.variantId;
    const quantity = Number(button.dataset.quantity);
    const status = form && form.querySelector('[data-tc-quick-add-status]');

    if (!form || !variantInput || !/^\d+$/.test(variantId || '') || quantity !== 1) {
      if (status) status.textContent = 'Unable to add this bottle. Please refresh and try again.';
      return;
    }

    const spinner = button.querySelector('.loading-overlay__spinner');
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const buttonLabel = button.querySelector('span:not(.sold-out-message)');
    const originalLabel = buttonLabel && buttonLabel.textContent;
    const onCartPage = window.location.pathname.replace(/\/$/, '') === window.routes.cart_url.replace(/\/$/, '');

    button.dataset.tcSubmitting = 'true';
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');
    if (status) status.textContent = 'Adding bottle to cart.';

    variantInput.disabled = false;
    variantInput.value = variantId;

    const formData = new FormData(form);
    formData.set('id', variantId);
    formData.set('quantity', '1');

    if (!onCartPage && cart && typeof cart.getSectionsToRender === 'function') {
      formData.set('sections', cart.getSectionsToRender().map(function (section) { return section.id; }).join(','));
      formData.set('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || 'Unable to add this bottle.');
        if (buttonLabel) buttonLabel.textContent = 'ADDED';
        if (status) status.textContent = 'Bottle added. Updating cart.';

        if (onCartPage) {
          window.setTimeout(function () { window.location.reload(); }, 180);
          return;
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else {
          return fetch(window.routes.cart_url + '.js')
            .then(function (cartResponse) { return cartResponse.json(); })
            .then(function (cartData) {
              const cartLink = document.querySelector('#cart-icon-bubble');
              if (cartLink) {
                let bubble = cartLink.querySelector('.cart-count-bubble');
                if (!bubble) {
                  bubble = document.createElement('div');
                  bubble.className = 'cart-count-bubble';
                  cartLink.appendChild(bubble);
                }
                bubble.innerHTML = '<span aria-hidden="true">' + cartData.item_count + '</span><span class="visually-hidden">' + cartData.item_count + ' items</span>';
              }
              if (buttonLabel) {
                window.setTimeout(function () { buttonLabel.textContent = originalLabel; }, 1600);
              }
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
            });
        }
      })
      .catch(function (error) {
        const soldOut = button.querySelector('.sold-out-message');
        if (soldOut) {
          button.querySelector('span:not(.sold-out-message)')?.classList.add('hidden');
          soldOut.textContent = error.message;
          soldOut.classList.remove('hidden');
        }
        if (status) status.textContent = error.message;
      })
      .finally(function () {
        if (onCartPage && buttonLabel && buttonLabel.textContent === 'ADDED') return;

        button.classList.remove('loading');
        button.disabled = false;
        delete button.dataset.tcSubmitting;
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  }, true);
})();
